exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".address-forms label[data-v-8a057a6c]{font-weight:700}.address-forms .help-block[data-v-8a057a6c]{color:red}.address-forms .address-label[data-v-8a057a6c]{font-size:13px}.address-forms .form-control.invalid[data-v-8a057a6c]{border-color:red}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8a057a6c","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/mypage/AddressForms.vue
// module id = R5fn
// module chunks = 1